<template>
  <div>
    <section class="trial-balance-wrapper">
      <b-row class="trial-balance justify-content-center">
        <b-col cols="10">
          <b-card no-body class="trial-balance-card">
   
            <b-card-body class="trial-balance-padding pb-0">
              <div class="d-flex justify-content-center flex-md-row flex-column mt-0">
                <div class="text-center">
                  <h1 class="trial-balance-logo">{{ this.userData.username }}</h1>
                  <h1 class="trial-balance-title">Trial Balance</h1>
                  <h3>As of {{ new Date().toISOString().split("T")[0]}}</h3>
                </div>
              </div>
            </b-card-body>

      
            <hr class="trial-balance-spacing" />

      
            <b-card-body class="trial-balance-padding py-4">
              <b-table-lite
                :items="tableData"
                :fields="fields"
                
                responsive
                bordered
                striped
                hover
                :tbody-tr-class="tbodyTrClass"
              ></b-table-lite>

               <!-- Total Section -->
            <b-row class="w-100">
              <b-col cols="6" class="mt-2">
                <h5 class="text-uppercase">Total</h5>
              </b-col>

              <b-col cols="6" class="mt-xl-0 mt-2 d-flex justify-content-end">
                <div class="font-weight-bolder justify-content-end text-right">
                  <hr class="my-50" />
                  <p class="card-text mb-25">Debit: {{ getTotalDebit() | formatCurrency }}</p>
                  <p class="card-text mb-25">Credit: {{ getTotalCredit() | formatCurrency }}</p>
                </div>
              </b-col>
            </b-row>
            </b-card-body>
          

           
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BButton,
  BTableLite,
  BRow,
  BCol,
  BCard,
  BCardBody
} from "bootstrap-vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BButton,
    BTableLite,
    BRow,
    BCol,
    BCard,
    BCardBody
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      //trialBalance: [],
      // fields: [{
      //             key: 'accountName',
      //             label: 'Account',
      //           },
      //            {
      //             key: 'category',
      //             label: 'Debit (MUR)',
      //             formatter: formatCurrency,
      //           }, {
      //             key: 'category',
      //             label: 'Credit (MUR)',
      //             formatter: formatCurrency,
      //           },
      //           ],
      dateFrom: "01-01-2024",
      dateTo: "12-12-2024",
    };
  },
  computed: {

    ...mapGetters("reportModule", {
      trialBalance: "trialBalance",
      loading: "loading",
    }),

    fields() {
    return [
      {
        key: 'accountName',
        label: 'Account',
      },
      {
        key: 'debit',
        label: 'Debit (MUR)',
        formatter: this.formatCurrency,
      },
      {
        key: 'credit',
        label: 'Credit (MUR)',
        formatter: this.formatCurrency,
      },
    ];
  },

    tableData() {
       const totalDebit = this.getTotalDebit();
       const totalCredit = this.getTotalCredit();
//console.log("balance", this.trialBalance);
      // return [
      //   ...this.trialBalance,
      //   { account: "Total (MUR)", debit: totalDebit, credit: totalCredit },
      // ];
      const tableData = this.trialBalance.map(item => {
        return {
          accountName: item.accountName,
          debit: item.category === "DEBIT" ? item.amount : 0,   
          credit: item.category === "CREDIT" ? item.amount : 0,
          // debittotal: totalDebit, 
          // credittotal: totalCredit
        };
      });

      tableData.push({
        accountName: "Total (MUR)",
        debit: totalDebit,
        credit: totalCredit,
      });

      return tableData
    },
  },
  methods: {
    ...mapActions("reportModule", ["getTrialBalanceReportAction"]),
    // getTotalDebit() {
    //   return this.trialBalance.reduce((total, { debit }) => total + debit, 0);
    // },
    // getTotalCredit() {
    //   return this.trialBalance.reduce((total, { credit }) => total + credit, 0);
    // },

    // Calculate total debit
    getTotalDebit() {
      return this.trialBalance.reduce((total, item) => {
        return item.category === "DEBIT" ? total + item.amount : total;
      }, 0);
    },

    // Calculate total credit
    getTotalCredit() {
      return this.trialBalance.reduce((total, item) => {
        return item.category === "CREDIT" ? total + item.amount : total;
      }, 0);
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("en-MU", {
        style: "currency",
        currency: "MUR",
      }).format(value);
    },
    tbodyTrClass(item) {
      if (item.account === "Total (MUR)") {
        return "total-row font-weight-bolder bg-secondary bg-darken-5";
      }
      return "";
    },
    exportAsPDF() {
      const doc = new jsPDF();
      doc.text("Trial Balance", 10, 10);
      doc.autoTable({
        head: [["Account", "Debit", "Credit"]],
        body: this.tableData.map(({ account, debit, credit }) => [
          account,
          this.formatCurrency(debit),
          this.formatCurrency(credit),
        ]),
        startY: 20,
      });
      doc.save("trial_balance.pdf");
    },
  },

  async mounted() {
 //console.log("date", this.dateFrom);
await this.getTrialBalanceReportAction({ dateFrom: this.dateFrom, dateTo: this.dateTo });

  }
};
</script>

<style lang="scss" scoped>
.trial-balance-wrapper {
  .trial-balance-title {
    font-size: 2rem;
    font-weight: bold;
  }
}
</style>
